import { Box } from '@zillow/constellation-10';
import MessageStatusIndicator, { type MessageStatusVariant } from './MessageStatusIndicator';
import MessageMetaLabel, { type MessageMetaLabelVariant } from './MessageMetaLabel';
import { Timestamp } from '../..';

type MessageFooterProps = {
  failureText?: string;
  isMessageOwner: boolean;
  messageDateMs: string;
  metaLabelType?: MessageMetaLabelVariant;
  resendMessage?: () => void;
  sendStatus?: MessageStatusVariant;
  shouldDisplaySentStatus?: boolean;
};

export default function MessageFooter({
  failureText,
  isMessageOwner,
  messageDateMs,
  metaLabelType,
  resendMessage,
  sendStatus,
  shouldDisplaySentStatus,
}: MessageFooterProps): JSX.Element {
  const shouldShowStatusIndicator = !!sendStatus && isMessageOwner;

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: isMessageOwner ? 'flex-end' : 'flex-start',
      }}
    >
      {shouldShowStatusIndicator && (
        <MessageStatusIndicator
          failureText={failureText}
          shouldDisplaySentStatus={shouldDisplaySentStatus}
          status={sendStatus}
          resendMessage={resendMessage}
        />
      )}

      {!!messageDateMs && <Timestamp messageDateMs={messageDateMs} />}

      {!!metaLabelType && <MessageMetaLabel metaLabelType={metaLabelType} />}
    </Box>
  );
}
